/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Region_Ankle_LInputs */

const en_us2_bodymap_region_ankle_l = /** @type {(inputs: Bodymap_Region_Ankle_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Left ankle or foot`)
};

const pt_br2_bodymap_region_ankle_l = /** @type {(inputs: Bodymap_Region_Ankle_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tornozelo ou pé esquerdo`)
};

const es_419_bodymap_region_ankle_l = /** @type {(inputs: Bodymap_Region_Ankle_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tobillo o pie izquierdo`)
};

const pt_pt2_bodymap_region_ankle_l = /** @type {(inputs: Bodymap_Region_Ankle_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tornozelo ou pé esquerdo`)
};

const fr_fr2_bodymap_region_ankle_l = /** @type {(inputs: Bodymap_Region_Ankle_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cheville ou pied gauche`)
};

const de_de2_bodymap_region_ankle_l = /** @type {(inputs: Bodymap_Region_Ankle_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Linkes Sprunggelenk oder Fuß`)
};

const it_it2_bodymap_region_ankle_l = /** @type {(inputs: Bodymap_Region_Ankle_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Caviglia o piede sinistro`)
};

/**
* | output |
* | --- |
* | "Left ankle or foot" |
*
* @param {Bodymap_Region_Ankle_LInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_region_ankle_l = /** @type {((inputs?: Bodymap_Region_Ankle_LInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Region_Ankle_LInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_region_ankle_l(inputs)
	if (locale === "es-419") return es_419_bodymap_region_ankle_l(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_region_ankle_l(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_region_ankle_l(inputs)
	if (locale === "de-DE") return de_de2_bodymap_region_ankle_l(inputs)
	if (locale === "it-IT") return it_it2_bodymap_region_ankle_l(inputs)
	return en_us2_bodymap_region_ankle_l(inputs)
});
export { bodymap_region_ankle_l as "bodymap.region.ankle_l" }